import React, { FC } from "react";
import Title from "../../../UI/organisms/Title/Title";

import "./Modules.scss";
import { ModulesType } from "./Types";
import Flag from "../../../UI/organisms/Flag/Flag";
import Accordion from "../../../UI/atoms/ModulesItems/Accordion";
import NormalItem from "../../../UI/atoms/ListItem/NormalItem";

const Modules: FC<ModulesType> = ({
  data: { title, list, flag },
  styleClass,
}) => {
  return (
    <>
      <section id="modules" className={`modules__content ${styleClass}`}>
        <Title info={title} tag="h2" />
        <ul className="modules__list">
          {list.map((info) =>
            info.subs ? (
              <Accordion key={info.title} {...info} />
            ) : (
              <NormalItem key={info.title} {...info} />
            )
          )}
        </ul>
      </section>
      {flag?.text && <Flag ico={flag.ico} text={flag.text} />}
    </>
  );
};

export default Modules;
